import { connect } from 'react-redux';
import { withGetCompany } from 'src/_shared/api/components/settings/';
import { dashboardActions } from 'src/actions.js';
import { compose } from '../../_shared/services/utils.js';
import { ReportBuilderComponent } from './ReportBuilderComponent.jsx';

const mapStateToProperties = (state) => {
	const { allMultiLingualData } = state.dashboard;
	return {
		currentUser: state.user.currentUser,
		companyId: state.user.currentUser.companyId,
		allMultiLingualData,
	};
};

const mapDispatchToProperties = (dispatch) => {
	return {
		setMultiLingualData(data) {
			dispatch(dashboardActions.createSetMultiLingualData(data));
		},
	};
};

const ReportBuilderWithAPI = compose(withGetCompany)(ReportBuilderComponent);

export const ReportBuilder = connect(
	mapStateToProperties,
	mapDispatchToProperties
)(ReportBuilderWithAPI);
